import React from 'react';
import styled from 'styled-components';
import * as Styles from '../styles';
import { SideSheetHeader } from '../SideSheet/SideSheet';
import { IconHelp } from 'cdk-radial';
import { useSideSheet } from '../../contexts/SideSheet';
import { useTranslation } from 'react-i18next';
import { CustomScrollbarWrapper } from 'cdk-radial';
import FocusTrap from 'focus-trap-react';
import DynamicHelp from './DynamicHelp';
import {resetWalkme} from '../Walkme/Walkme';
 
export const StyledCustomScrollbarWrapper = styled(CustomScrollbarWrapper)`
  height: calc(100vh - 80px);
  overflow-x: hidden;
`;
const FeaturedHelpLink = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  font-size: 24px;
  svg {
    width: 40px;
    height: 40px;
  }
`;
const HelpSheetContent = styled.div`
  font-family: 'Montserrat', 'Roboto', sans-serif;
  font-size: 1rem;
  // TODO: shouldn't need to do this but don't know where line height is inheriting from
  line-height: normal;
`;

const Help = React.memo(() => {

  const { setSideSheetContent } = useSideSheet();
  const { t } = useTranslation();

  const toggle = () => {
    resetWalkme();
    setSideSheetContent(null);
  };

  return (
    <FocusTrap active={true}
    focusTrapOptions={{
      clickOutsideDeactivates: true,
                    tabbableOptions: {
                        displayCheck: 'none'
                    }
                }}>
    <HelpSheetContent>
      <SideSheetHeader
        name={t('help.name')}
        toggle={toggle}
        dataTestId="help-tab-header"
      />
      <StyledCustomScrollbarWrapper>
        <Styles.SideSheetBody>
          <FeaturedHelpLink>
            <IconHelp />
            <h4>{t('help.topHelpTopics')}</h4>
          </FeaturedHelpLink>
          <div style={{ margin: '-20px' }}>
            <DynamicHelp />
          </div>
        </Styles.SideSheetBody>
      </StyledCustomScrollbarWrapper>
    </HelpSheetContent>
    </FocusTrap>
  );
});
export default Help;
